<div class="statusbadge statusbadge--{{this.status}} statusbadge--{{this.size}}"></div>
